import { render, staticRenderFns } from "./PaymentMethodDescription.vue?vue&type=template&id=f3e81084&"
import script from "./PaymentMethodDescription.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports